export default __webpack_public_path__ + "b65e8969acf17fcf731e184d8417e52a.png";